import React from 'react';
import { useMediaQuery } from 'react-responsive';
import Container from '../General/Container';
import Panel from '../UI/Panel';
import PanelContent from './PasswordChangePanelContent';
import {
  WrapperStyled,
  SvgHeaderWrapperStyled,
  ContentWrapperStyled,
  TextBlockStyled,
  AltStrongStyled,
  ActivatorPanelText,
} from './styles/PasswordChangeBlockStyled';
import {
  BrowserIcon,
  IpSearchIcon,
  AccountIcon,
  BrowserLockIcon,
  BrowserPassIcon,
} from '../../images/consejos-bam';
import cambiarPassword from '../../images/consejos-bam/cambiar-password.png';

const PasswordChangeBlock = () => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });
  return (
    <WrapperStyled>
      <SvgHeaderWrapperStyled>
        <img src={cambiarPassword} alt="Cambiar Password" />
      </SvgHeaderWrapperStyled>
      <Container padding="0px" background="transparent" boxShadow="none">
        <ContentWrapperStyled>
          <TextBlockStyled>
            <BrowserIcon />
            <p>
              Abre el <strong> navegador </strong>
              de tu computador o celular (Chrome, Firefox, Safari, etc)
            </p>
          </TextBlockStyled>
          <TextBlockStyled>
            <IpSearchIcon />
            <p>
              En la <strong> barra de dirección </strong>
              ingresa uno de los siguiente números, dependiendo de tu router,
              usa puntos y sin espacios:
            </p>
            <Panel
              isMobileDevice={isMobileDevice}
              bodyColor="#E6E2E8"
              maxWidth="360px"
              showClose
              title="Para cambiar tu contraseña"
              activator={({ setShow }) => (
                <ActivatorPanelText onClick={() => setShow(true)}>
                  <p>Ver números</p>
                </ActivatorPanelText>
              )}
            >
              {() => <PanelContent />}
            </Panel>
          </TextBlockStyled>
          <TextBlockStyled>
            <AccountIcon />
            <p>
              Cuando entres al
              <strong> menú </strong>, dirígete a la pestaña &quot;
              <strong>Configuración</strong>&quot; o &quot;
              <strong>Configuraciones</strong>&quot;
              <AltStrongStyled>Usuario y contraseña: admin</AltStrongStyled>
            </p>
          </TextBlockStyled>
          <TextBlockStyled>
            <BrowserLockIcon />
            <p>
              Para <strong> cambiar </strong> el
              <strong> nombre de la red </strong>
              (nombre con el que va a ser reconocida tu red por otros
              dispositivos)
              <strong> debes seleccionar SSID </strong>y cambiarla.
            </p>
          </TextBlockStyled>
          <TextBlockStyled>
            <BrowserPassIcon />
            <p>
              Para <strong> modificar tu contraseña </strong>
              de red debes seleccionar
              <strong> Clave de red compartida </strong>o contraseña y cambiarla
              por la que más te acomode, recuerda, debe ser
              <strong> mínimo 8 caracteres.</strong>
            </p>
          </TextBlockStyled>
        </ContentWrapperStyled>
      </Container>
    </WrapperStyled>
  );
};

export default PasswordChangeBlock;
